import React from 'react';
import ButtonProps from '@/types/button';
import { buttonColorClass } from "@/utils/helpers";

import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import styles from "./Cta.module.css";

interface CTAProps {
	sectionBgColor?: string;
	title: string;
	content: string;
	button?: ButtonProps;
}

const CTA: React.FC<CTAProps> = ({ sectionBgColor, title, content, button }) => {

	return (
		<section
			className={styles.cta}
			style={{ backgroundColor: sectionBgColor || '#F9F7F4' }}
		>
			<div className="max-w-4xl mx-auto px-4 sm:px-6 xl:px-0 text-center">
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
				>
					<h2
						className={`${styles.ctaTitle} font-normal text-black font-abc-prophet text-4xl leading-tight lg:text-[58px] lg:leading-[76px]`}
					>
						{title}
					</h2>
					<p className="text-xl lg:text-[24px] text-black font-karla mb-8">
						{content}
					</p>
					{
						(button && button?.buttonTitle) && (
							<Link to={button?.buttonUrl || "#"} className="inline-block" target={button?.openNewTab ? "_blank" : "_self"}>
								<Button
									type='button'
									className={`${styles.ctaButton} ${buttonColorClass(button?.buttonColor)} text-black py-[14px] px-[20px] shadow-btn-shadow font-karla text-[20px] h-auto`}
								>
									{button?.buttonTitle} <span aria-hidden="true" className='ml-1'>&rarr;</span>
								</Button>
							</Link>
						)
					}
				</motion.div>
			</div>
		</section>
	);
}

export default CTA;